// Serviço de API usando localStorage como armazenamento

// Dados iniciais (serão carregados no localStorage se estiver vazio)
const initialData = {
    projects: [
        {
            name: "LIFE",
            budget: "1600",
            category: { id: "2", name: "Desenvolvimento" },
            cost: 0,
            services: [],
            id: 1
        },
        {
            name: "ZIRA",
            budget: "12000",
            category: { id: "2", name: "Desenvolvimento" },
            cost: 600,
            services: [
                {
                    name: "Contratar DEV PQP",
                    cost: "500",
                    description: "Vai Criar a função de envio de emails",
                    id: "8ad3a7d9-b8ab-4fd6-a398-765e459c6f2f"
                },
                {
                    name: "Novo serviço",
                    cost: "100",
                    description: "teste",
                    id: "bd958931-93cb-4e36-84af-8354bc502642"
                }
            ],
            id: 2
        }
    ],
    categories: [
        { id: 1, name: "Infra" },
        { id: 2, name: "Desenvolvimento" },
        { id: 3, name: "Design" },
        { id: 4, name: "Planejamento" }
    ]
};

// Inicializa o localStorage com dados iniciais se estiver vazio
function initializeStorage() {
    if (!localStorage.getItem('costs_projects')) {
        localStorage.setItem('costs_projects', JSON.stringify(initialData.projects));
    }
    if (!localStorage.getItem('costs_categories')) {
        localStorage.setItem('costs_categories', JSON.stringify(initialData.categories));
    }
}

// Inicializa ao carregar o módulo
initializeStorage();

// Funções auxiliares para acessar localStorage
function getProjects() {
    const data = localStorage.getItem('costs_projects');
    return data ? JSON.parse(data) : [];
}

function saveProjects(projects) {
    localStorage.setItem('costs_projects', JSON.stringify(projects));
}

function getCategories() {
    const data = localStorage.getItem('costs_categories');
    return data ? JSON.parse(data) : [];
}

// Gera um novo ID único
function generateId() {
    const projects = getProjects();
    const maxId = projects.reduce((max, p) => Math.max(max, p.id || 0), 0);
    return maxId + 1;
}

// API Functions
export const fetchProjects = async () => {
    // Simula delay de rede
    await new Promise(resolve => setTimeout(resolve, 100));
    return getProjects();
};

export const fetchProject = async (id) => {
    await new Promise(resolve => setTimeout(resolve, 100));
    const projects = getProjects();
    return projects.find(p => p.id === parseInt(id)) || null;
};

export const createProject = async (project) => {
    await new Promise(resolve => setTimeout(resolve, 100));
    const projects = getProjects();
    const newProject = {
        ...project,
        id: generateId(),
        cost: project.cost || 0,
        services: project.services || []
    };
    projects.push(newProject);
    saveProjects(projects);
    return newProject;
};

export const updateProject = async (project) => {
    await new Promise(resolve => setTimeout(resolve, 100));
    const projects = getProjects();
    const index = projects.findIndex(p => p.id === parseInt(project.id));
    if (index !== -1) {
        projects[index] = { ...projects[index], ...project };
        saveProjects(projects);
        return projects[index];
    }
    return project;
};

export const deleteProject = async (id) => {
    await new Promise(resolve => setTimeout(resolve, 100));
    const projects = getProjects();
    const filteredProjects = projects.filter(p => p.id !== parseInt(id));
    saveProjects(filteredProjects);
    return { success: true };
};

export const fetchCategories = async () => {
    await new Promise(resolve => setTimeout(resolve, 100));
    return getCategories();
};

// Função para resetar os dados (útil para testes)
export const resetData = () => {
    localStorage.setItem('costs_projects', JSON.stringify(initialData.projects));
    localStorage.setItem('costs_categories', JSON.stringify(initialData.categories));
};
